import i18n from 'i18next';

/**
 * Утилита для получения переводов вне React компонентов
 * Использует прямой доступ к экземпляру i18n
 */
export const translate = (key: string, params?: any): string => {
  if (!isI18nReady()) {
    console.warn('i18n not initialized, returning fallback:', key);
    return key;
  }

  return i18n.t(key, params) as unknown as string;
};

/**
 * Проверка, инициализирован ли i18n
 */
export const isI18nReady = (): boolean => {
  return i18n.isInitialized;
};
